import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const ViewVehicleListByAddress = async (
  action,
  bundleId,
  crmRefId,
  addressContactList,
  partRecommendationRequest,
  actionType,
  priority,
  providerOrderNumber,
  modifiedBy,
  salesOrgId
) => {
  try {
    const payload = {
      //action,

      crmRefId,
      bundleShippingGroups: [
        {
          bundleId,
          ...(partRecommendationRequest ? { partRecommendationRequest } : {}),
          shippingAddressContactList: addressContactList,
        },
      ],
      ...(actionType ? { actionType } : {}),
      ...(priority !== undefined && priority !== null ? { priority } : {}),
      ...(providerOrderNumber ? { providerOrderNumber } : {}),
      ...(modifiedBy ? { modifiedBy } : {}),
      ...(salesOrgId ? { salesOrgId } : {}),
    };
    const response = await postRequest(urls.WT_VIEW_VEHICLE_LIST_BY_ADDRESS, payload);
    return response;
  } catch (err) {
    return err;
  }
};

export const ViewVehicleListByAddressOnly = async (payload) => {
  try {
    const response = await postRequest(urls.WT_VIEW_VEHICLE_LIST_BY_ADDRESS, payload);
    return response;
  } catch (err) {
    return err;
  }
};

export const postApplyActions = async (payload) => {
  try {
    const response = await postRequest(urls.POST_APPLY_ACTIONS, payload);
    return response;
  } catch (err) {
    return err;
  }
};

export const fetchVehicleByInstallationAddress = async (payload) => {
  try {
    const response = await postRequest(urls.FETCH_VEHICLE_BY_INSTALLATION_ADDRESS, payload);
    return response;
  } catch (err) {
    return err;
  }
};
